export const Login = "auth/login";
export const Signup = "auth/signup";
export const Logout = "auth/logout";